import React, { useEffect, useState } from 'react';
import { activetabslice, darkmodeslice, fontsizeslice } from '../store/navigationSlice';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { IoCloseSharp } from "react-icons/io5";
import { useReadArticles } from '../hooks/useReadArticles';
import useGoogleAuth from './useGoogleAuth';
import { logout } from 'store/authSlice';
import { useNavigate } from 'react-router-dom';


interface TabsProps {
  activeTab: string;
  darkMode: boolean;
  fontSize: string;
  loading: boolean;
}

const Tabs: React.FC<TabsProps> = ({
  activeTab,
  darkMode,
  fontSize,
  loading
}) => {
  const navigate = useNavigate(); 
  useGoogleAuth();     
  const userLoggedStatus = useAppSelector((state:any) => state.auth.isAuthenticated); 
  const settingLocalData = useAppSelector((state: any) => state.staticSettingSlice.data);  
 const getdevice = useAppSelector((state: any) => state.getPlatformSlice.data);
 const dispatch = useAppDispatch();
//  const [platform, setPlatform] = useState<MobilePlatform>("other");
const setActiveTab = (value:string) => {
   dispatch(activetabslice(value))  
}

const setDarkMode = (value:boolean) => {
   dispatch(darkmodeslice(value))  
}

const setFontSize = (value:string) => {
  dispatch(fontsizeslice(value))  
}
  const { clearAllReadArticles, getReadArticlesLength } = useReadArticles();
  const readArticleLength = getReadArticlesLength();

   const staticPage = (val:string) => {
    setActiveTab('home');
      navigate(val)      
   }



  function callReactNativeFunction(value: string) {
    // console.log(value, "value location")
    if (window.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(`callReactNativeFunction:${value}`);
    } else {
      alert("This feature is only available in the mobile app.");
    }
  }


  return (
    <>
    
      {/* Profile Settings (Only visible when profile tab is active) */}
      {activeTab === 'profile' && (
        <div className={`fixed inset-0 z-20 pt-16 pb-16 ashok-profile ${darkMode ? 'bg-gray-900' : 'bg-gray-100'}`}>        
          <div className="container mx-auto px-4 pt-2">                 
            <div className="flex items-center justify-end mb-4">
              <button 
                onClick={() => setActiveTab('home')}
                className={`px-1 py-1 text-xs rounded !rounded-button ${
                  fontSize === 'small' 
                    ? darkMode ? 'text-orange-400' : 'text-gray-800' 
                    : darkMode ? 'text-orange-400' : 'text-gray-800'
                }`}> 
                <IoCloseSharp size={20} />
              </button>
            </div>                
          </div>
          
          <div className="container mx-auto px-4 py-0">
            <h2 className={`text-xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-800'}`}>Settings</h2>
            
            <div className={`rounded-lg shadow-md p-4 mb-4 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>

              <div className={`flex items-center justify-between mb-4 pb-2 border-b ${darkMode ? ('border-gray-700'):('border-gray-200')}`}>
                <div className="flex items-center">
                  <i className={`fas fa-moon mr-3 ${darkMode ? 'text-orange-400' : 'text-gray-600'}`}></i>
                  <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Dark Mode</span>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    checked={darkMode} 
                    onChange={() => setDarkMode(!darkMode)} 
                    className="sr-only peer"
                  />
                  <div className={`w-11 h-6 rounded-full peer ${
                    darkMode ? 'bg-orange-500' : 'bg-gray-300'
                  } peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all`}></div>
                </label>
              </div>
              
              <div className={`flex items-center justify-between mb-4 border-b pb-2 ${darkMode ? ('border-gray-700'):('border-gray-200')}`}>
                <div className="flex items-center">
                  <i className={`fas fa-font mr-3 ${darkMode ? 'text-orange-400' : 'text-gray-600'}`}></i>
                  <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Font Size</span>
                </div>
                <div className="flex space-x-2">
                  <button 
                    onClick={() => setFontSize('small')} 
                    className={`px-3 py-1 text-xs rounded !rounded-button ${
                      fontSize === 'small' 
                        ? darkMode ? 'bg-orange-500 text-white' : 'bg-orange-500 text-white' 
                        : darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                    }`}>
                    Small
                  </button>
                  <button 
                    onClick={() => setFontSize('medium')} 
                    className={`px-3 py-1 text-xs rounded !rounded-button ${
                      fontSize === 'medium' 
                        ? darkMode ? 'bg-orange-500 text-white' : 'bg-orange-500 text-white' 
                        : darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                    }`}>
                    Medium
                  </button>
                  <button 
                    onClick={() => setFontSize('large')} 
                    className={`px-3 py-1 text-xs rounded !rounded-button ${
                      fontSize === 'large' 
                        ? darkMode ? 'bg-orange-500 text-white' : 'bg-orange-500 text-white' 
                        : darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                    }`}
                  >
                    Large
                  </button>
                </div>
              </div>              
              

              <div className={`hidden items-center justify-between mb-4 border-b pb-2 ${darkMode ? ('border-gray-700'):('border-gray-200')}`}>      
                 <div className="flex items-center">
                  <i className={`fas fa-moon mr-3 ${darkMode ? 'text-orange-400' : 'text-gray-600'}`}></i>
                  <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>मेरा प्रोफाइल</span>
                </div>

                {userLoggedStatus ? (<button 
                  onClick={() =>dispatch(logout())}
                  className={`px-3 py-1 text-xs rounded !rounded-button ${darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                  }`}>
                  <i className="fas fa-share-alt mr-1"></i> Logout
                </button>):(<button 
                  onClick={() =>{
                    navigate('/login');
                    setActiveTab('home');
                  } }
                  className={`px-3 py-1 text-xs rounded !rounded-button ${darkMode ? 'bg-orange-500 text-white' : 'bg-orange-500 text-white'}`}>
                  <i className="fas fa-share-alt mr-1"></i> लॉगिन
                </button>)}                                 
              </div>


                   <div className={`flex items-center justify-between border-b pb-2 mb-4 ${darkMode ? ('border-gray-700'):('border-gray-200')}`}>      
               
                <button 
                  onClick={() =>clearAllReadArticles()}
                  className={`px-3 py-1 text-sm rounded !rounded-button ${
                    readArticleLength > 0 ?
                    darkMode ? 'bg-orange-500 text-white' : 'bg-orange-500 text-white'
                    :darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                  }`}>
                  <i className="fas fa-share-alt mr-1"></i> {readArticleLength > 0 ? ('Clear Article History'):('No History')}
                </button>                 
              </div>


              <div className="flex items-center justify-between" onClick={() => callReactNativeFunction("https://bharat24live.com/download.html")}>
                <div className="flex items-center">
                  <i className={`fas fa-user-plus mr-3 ${darkMode ? 'text-orange-400' : 'text-gray-600'}`}></i>
                  <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-800'}`}>Share app to Friends</span>
                </div>


                 <div className="flex items-center justify-between" >      
        <div className="flex space-x-2">
          <div className="d-hide justify-content-between mb-1 mt-1 app-share">
            <img              
              src="/images/icons/react-share.webp"
              width="30"
              height="30"
              alt="Share article"
              style={{ cursor: 'pointer' }}
              role="button"
              aria-label="Share article"
            />
          </div>
        </div>
      </div>



                {/* <a href="https://bharat24live.com/download.html" target="_blank" className="px-3 py-1 text-sm rounded bg-green-600 text-white">Share on WhatsApp</a> */}
{/* <button
  onClick={() => {
    const message = `Check out this amazing news app! Download now: https://bharat24live.com/download.html`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  }}
  className={`px-3 py-1 text-sm rounded !rounded-button ${
    darkMode ? 'bg-green-600 text-white' : 'bg-green-600 text-white'
  }`}
>
  <i className="fab fa-whatsapp mr-1"></i> Share on WhatsApp
</button> */}


              </div>


   
            </div>

             <div className={`rounded-lg shadow-md p-4 mb-5 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
                  {settingLocalData?.footerlink?.map((item:any, index:number)=> {
                    return(<div key={index} className='flex' onClick={()=>staticPage(item?.slug)}>{item?.title}</div>);
                  })}
            </div>
            
            <div className={`rounded-lg shadow-md p-4 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
              <h3 className={`font-medium mb-3 ${darkMode ? 'text-white' : 'text-gray-800'}`}>About</h3>
              <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                bharat24live app v1.0.0<br />
                Last updated: June 6, 2025
              </p>
            </div>


            
          </div>
        </div>
      )}     
    </>
  );
};

export default Tabs;